function handlePromise(promise) {
  return promise
    .then(data => [null, data])
    .catch(error => Promise.resolve([error, undefined]));
}

export { handlePromise };
